<!--
  Login.vue
    Login form Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <v-app>
    <div class="hm-login-form" @keyup.enter="onLoginClick">
      <p class="hm-login-title">Here's Me</p>

      <div :class="{'hm-hide': onLoginProgress}">

      <v-form v-model="mFormValid">
        <v-text-field
          label="アカウントID"
          v-model="accountId"
          type='email'
          :rules="accountIdRules"
          required
        ></v-text-field>
        <v-text-field
          label="パスワード"
          v-model="password"
          :type="mPwVisible ? 'text' : 'password'"
          :append-icon="mPwVisible ? 'visibility_off' : 'visibility'"
          :rules="passwordRules"
          required
          @click:append="mPwVisible = !mPwVisible"
        ></v-text-field>
      </v-form>

      <div class="hm-login-failmsg">
        <span v-html="mLoginFailMsg"></span>
      </div>

      <div class="hm-login-btn">
        <v-btn color="primary" @click="onLoginClick">LOGIN</v-btn>
      </div>

      </div><!-- hm-hide -->

      <div :class="{'hm-hide': !onLoginProgress}">

        <div class="hm-login-progress">
          ログインしています...
          <v-progress-linear :indeterminate="true" color="primary" />
        </div>

      </div><!-- hm-hide -->

      <p class="hm-login-version">
        ver.{{ app_version }}
      </p>
    </div>

    <!-- ダイアログ -->
    <confirm-dialog ref="confirmDialog">
      <div slot="msg">{{mConfirmMsg}}</div>
    </confirm-dialog>
    <info-dialog ref="SystemInfoDialog">
      <div slot="msg">{{mSysInfoMsg}}</div>
    </info-dialog>

  </v-app>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { mapState } from 'vuex'
import {
  APP_VERSION,
  isNullorUndefined
} from '@/common'
import { ROUTE_PATH } from '@/router/routes'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog'
import SystemInfoDialog from '@/components/dialogs/SystemInfoDialog'

export default {
  name: 'Login',
  data: () => ({
    mLoginProgress: false,
    app_version: APP_VERSION,
    mFormValid: false,
    accountId: '',
    accountIdRules: [
      v => !!v || 'アカウントIDが未入力です',
    ],
    password: '',
    passwordRules: [
      v => !!v || 'パスワードが未入力です',
    ],
    mPwVisible: false,
    mLoginFailMsg: ' ',
    mAllowRetry: false,
    mConfirmMsg: '',
    mSysInfoMsg: '',
    //mStoreUrl: '',
    //mAppStoreUrl: 'https://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1255733654&mt=8',
    //mAppStoreUrl: 'itms-apps://itunes.apple.com/app/id1255733654?mt=8',
    //mGoogleStoreUrl: 'https://play.google.com/store/apps/details?id=com.microsamerica.imhere&hl=ja',
    //mGoogleStoreUrl: 'market://details?id=com.microsamerica.imhere',
  }),
  components: {
    'confirm-dialog': ConfirmDialog,
    'info-dialog': SystemInfoDialog,
  },
  mounted: function () {
    this.$log.debug('# Login')
    if (this.isMobile) {
      document.addEventListener('deviceready', this.onDeviceReady, false)
    }
    // ログイン、token履歴をcheck
    this.$store.commit('checkLoginStorage')
    // tokenが存在する場合はtoken認証を行う
    if (!isNullorUndefined(this.$store.getters.storedLoginId) &&
        !isNullorUndefined(this.$store.getters.accessToken)) {
      this.loginByToken()
    }
  },
  destroyed: function () {
    this.$log.debug('# Login')
  },
  computed: {
    ...mapState({
      isMobile: state => state.sIsMobile
    }),
    onLoginProgress: function () {
      return this.mLoginProgress
    },
    isAllowRetry: function () {
      return this.mAllowRetry
    },
  },
  methods: {
    // -------------------------------------------------------------------------
    // デバイスがReadyになったときの処理(Mobile only)
    onDeviceReady: function () {
      this.$store.commit('setIsDeviceReady', true)
      // back keyタップ時の処理を登録(Android only)
      document.addEventListener('backbutton', this.onBackKeyDown, false)
    },
    // -------------------------------------------------------------------------
    // back keyタップ時の処理
    // ログイン画面でタップされた場合はアプリを終了する
    onBackKeyDown: function () {
      navigator.app.exitApp()
    },
    // -------------------------------------------------------------------------
    // ログインボタンクリック時の処理
    // Credentialで認証する
    onLoginClick: function () {
      if (!this.mFormValid) {
        this.mLoginFailMsg = '未入力の項目があります'
        return
      }

      this.loginByCredentials()
    },
    // -------------------------------------------------------------------------
    // Credential認証ログイン
    loginByCredentials: async function () {
      this.mLoginProgress = true

      // ログイン
      let result = await this.$store.dispatch(
        'aLoginProc',
        {
          id: this.accountId,
          passwd: this.password,
        })

      if (!result.error && !result.body.error) {
        this.$log.info(
          'login success. - ' + this.accountId +
          ' : ' + result.body.body.user_id + ' : ' + result.body.body.company_id)

        // ログイン状態を更新
        this.$store.dispatch('aChangeLoginStatus', true)
        this.$store.dispatch('aSetLoginUserAllInfo', result.body.body)
        // ログイン後はMainContententsに遷移
        this.$router.push(ROUTE_PATH.ROUTE_MAIN_CONTENT)
      }
      else {
        this.$log.error('login failed.')
        this.mLoginProgress = false
        switch (result.status) {
          case 'Unauthorized':
            this.mLoginFailMsg = 'ログインに失敗しました<br />ID/Passwordが違います'
            break
          case 'NoResponse':
            this.mLoginFailMsg = 'サーバとの通信に失敗しました'
            break
          case 'Suspended':
            this.mLoginFailMsg = '契約期間終了のため、ご利用いただけません。<br>契約継続をご希望の場合はお問い合わせください。'
            break
          case 'VerError':
            if (this.isMobile) {
              /*let userAgent = checkUserAgent()
              if (userAgent.match(/iPhone/) !== null) {
                this.mStoreUrl = this.mAppStoreUrl
              }
              else {
                this.mStoreUrl = this.mGoogleStoreUrl
              }*/
              this.mSysInfoMsg = 'ご利用可能な最新バージョンがあります。アプリを更新してご利用ください。'
              this.$refs.SystemInfoDialog.$emit('show')
            }
            else {
              this.mConfirmMsg = 'ご利用可能な最新バージョンがあります。更新しますか？'
              this.$refs.confirmDialog.$emit('show', this.reloadPage)
            }
            break
          case 'IpError':
            this.mLoginFailMsg = 'このIPアドレスからのアクセスは<br>許可されていません'
            break
          default:
            this.mLoginFailMsg = 'ログインに失敗しました'
            break
        }
      }
    },
    // -------------------------------------------------------------------------
    // Token認証ログイン
    loginByToken: async function () {
      this.mLoginProgress = true

      let result = await this.$store.dispatch('aLoginProcByToken')

      if (!result.error && !result.body.error) {
        this.$log.info(
          'token login success. - ' + this.$store.getters.storedLoginId +
          ' : ' + result.body.body.user_id + ' : ' + result.body.body.company_id)

        // ログイン状態を更新
        this.$store.dispatch('aChangeLoginStatus', true)
        this.$store.dispatch('aSetLoginUserAllInfo', result.body.body)
        // ログイン後はMainContententsに遷移
        this.$router.push(ROUTE_PATH.ROUTE_MAIN_CONTENT)
      }
      else {
        // token認証に失敗した場合は、ID/PWログイン画面を表示する
        this.mLoginProgress = false
        switch (result.status) {
          case 'NoResponse':
            this.mLoginFailMsg = 'サーバとの通信に失敗しました<br />再度ログインして下さい'
            break
          case 'Suspended':
            this.mLoginFailMsg = '契約期間終了のため、ご利用いただけません。<br>契約継続をご希望の場合はお問い合わせください。'
            break
          case 'VerError':
            if (this.isMobile) {
              /*let userAgent = checkUserAgent()
              if (userAgent.match(/iPhone/) !== null) {
                this.mStoreUrl = this.mAppStoreUrl
              }
              else {
                this.mStoreUrl = this.mGoogleStoreUrl
              }*/
              this.mSysInfoMsg = 'ご利用可能な最新バージョンがあります。アプリを更新してご利用ください。'
              this.$refs.SystemInfoDialog.$emit('show')
            }
            else {
              this.mConfirmMsg = 'ご利用可能な最新バージョンがあります。更新しますか？'
              this.$refs.confirmDialog.$emit('show', this.reloadPage)
            }
            break
          case 'IpError':
            this.mLoginFailMsg = 'このIPアドレスからのアクセスは<br>許可されていません'
            break
          default:
            this.mLoginFailMsg = 'ログインに失敗しました<br />再度ログインして下さい'
            break
        }
      }
    },
    // -------------------------------------------------------------------------
    // アプリストアページへ遷移
    /*appStorePageOpen: function () {
      location.href = this.mStoreUrl
      //window.open(this.mStoreUrl, '_blank')
    },*/
    // -------------------------------------------------------------------------
    // 強制リロード
    reloadPage: function () {
      location.reload(true)
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-login-form {
  height: 440px;
  width: 400px;
  margin: 60px auto;
  padding: 10px 20px;
  border: solid 5px #8b0000;
  border-radius: 10px;          /* css3 draft */
  -webkit-border-radius: 10px;  /* Safari, Chrome */
  -moz-border-radius: 10px;     /* Firefox */
}
@media screen and (max-width: 600px) {
.hm-login-form {
  width: 90%;
}
}
.hm-login-title {
  margin-bottom: 50px;
  text-align: center;
  font-weight: bold;
  font-size: 2em;
  color: #8b0000;
}
.hm-login-btn {
  margin-top: 5vh;
  text-align: center;
}
.hm-login-version {
  margin-top: 20px;
  text-align: center;
  color: lightgray;
}

.hm-login-failmsg {
  height: 20px;
  margin-top: 10px;
  color: #ff0000;
  text-align: center;
}
.hm-login-progress {
  margin-bottom: 60px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue